<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <WarehouseTabs
        :warehouse="warehouse"
        v-model="currentTab"
        @delete="deleteWarehouse"
        @edit="editWarehouse"
        @empty="emptyWarehouse"
      />

      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="warehouse">
          <WarehouseDetails :key="currentTab == 'warehouse'" :warehouse="warehouse"/>
        </v-tab-item>
        <v-tab-item value="warehouse-product">
          <WarehouseProductDetails v-if="currentTab == 'warehouse-product'" :warehouse="warehouse"/>
        </v-tab-item>
        <v-tab-item value="warehouse-load">
          <WarehouseLoadDetails v-if="currentTab == 'warehouse-load'" :warehouse="warehouse"/>
        </v-tab-item>
        <v-tab-item value="warehouse-unload">
          <WarehouseUnloadDetails v-if="currentTab == 'warehouse-unload'" :warehouse="warehouse"/>
        </v-tab-item>
        <v-tab-item value="warehouse-transfer">
          <WarehouseTransferDetails v-if="currentTab == 'warehouse-transfer'" :warehouse="warehouse"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { warehousesService } from '../../utils/services/warehouses.service';
  import WarehouseTabs from '../../components/app/Warehouses/WarehouseTabs';
  import WarehouseDetails from '../../components/app/Warehouses/WarehouseDetails';
  import WarehouseLoadDetails from '../../components/app/Warehouses/WarehouseLoadDetails';
  import WarehouseUnloadDetails from '../../components/app/Warehouses/WarehouseUnloadDetails';
  import WarehouseTransferDetails from '../../components/app/Warehouses/WarehouseTransferDetails';
  import WarehouseProductDetails from '../../components/app/Warehouses/WarehouseProductDetails';
  import WarehouseModal from '../../components/modals/Warehouses/WarehouseModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'WarehouseShow',
    components: {
        Loader,
        WarehouseTabs,
        WarehouseDetails,
        WarehouseLoadDetails,
        WarehouseUnloadDetails,
        WarehouseTransferDetails,
        WarehouseProductDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        warehouse: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchWarehouse(id) {
        return warehousesService.get(id)
        .then(response => {
          this.warehouse = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteWarehouse() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return warehousesService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(`/${this.routeName.WAREHOUSE}`);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },

      async emptyWarehouse() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return warehousesService.reset(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('EMPTIED') });
                this.$router.push(`/${this.routeName.WAREHOUSE}`);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },

      async editWarehouse() {
          this.showModal({
              component: WarehouseModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('ZONE'),
                onSave: (
                  form,
                  error,
                ) => warehousesService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchWarehouse(this.id);
      this.loading = false;
    },
  };
</script>
